/**
 * Environment Variables
 */
const env = window['LUCID_SPA_CONFIG'];

export const APP_VERSION = env?.APP_VERSION || '';
export const DEPLOYMENT_ENV = env?.REACT_APP_DEPLOYMENT_ENV || 'local';
export const API_MOCK_ENABLED = import.meta.env.VITE_APP_API_MOCK || false;
export const SENTRY_DSN = env?.REACT_APP_SENTRY_DSN || '';
export const AMPLITUDE_KEY = env?.AMPLITUDE_KEY || '';
export const AMPLITUDE_ENABLED = env?.AMPLITUDE_ENABLED || false;

/**
 * Routes
 */
export const ROUTES = {
  home: '/',
  logout: '/logout',
  admin: '/impact-measurement/admin',
  im: '/impact-measurement/',
  imAdminCampaigns: '/impact-measurement/admin/campaigns',
  adminCampaign: '/admin/campaign',
  adminCampaigns: '/admin/campaigns',
  appcues: '/appcues-redirect/',
  campaignManager: '/admin/campaign-manager/',
  campaignManagerLanding: '/admin/campaign-manager/new'
};

/**
 * API URLs
 */
export const URLS = {
  API: '/api/v1',
  IM_UI: 'https://measurement.cint.com/studies'
};
